import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

type DetailItemProps = {
  label: string;
  value: string;
  optional?: boolean;
};

const DetailItem = ({ label, value, optional = false }: DetailItemProps) => (
  <Box column gap={8} mv={16}>
    <Text variant="bodySmBold" color="mono700">
      {label}
    </Text>
    <Text>{value}</Text>
    {optional && (
      <Text
        variant="captions"
        color="mono700"
        i18n="requests_feed.time_off.details.optional"
      />
    )}
  </Box>
);

export default DetailItem;
